import React, { useEffect } from 'react';
import './FloatingParticles.css';

const FloatingParticles = () => {
  useEffect(() => {
    const symbols = ['✨', '🌟', '⭐', '💫', '🔮', '🌙', '☄️'];
    
    const createParticle = () => {
      const particle = document.createElement('div');
      particle.className = 'particle';
      particle.textContent = symbols[Math.floor(Math.random() * symbols.length)];
      
      // Random position and timing
      particle.style.left = Math.random() * 100 + '%';
      particle.style.animationDuration = (Math.random() * 10 + 10) + 's';
      particle.style.animationDelay = Math.random() * 5 + 's';
      
      const container = document.querySelector('.floating-particles');
      if (container) {
        container.appendChild(particle);
        
        // Remove particle after animation
        setTimeout(() => {
          if (particle.parentNode) {
            particle.parentNode.removeChild(particle);
          }
        }, 15000);
      }
    };
    
    // Create particles periodically
    const interval = setInterval(createParticle, 3000);
    
    // Create initial particles
    for (let i = 0; i < 5; i++) {
      setTimeout(createParticle, i * 1000);
    }
    
    return () => {
      clearInterval(interval);
    };
  }, []);

  return <div className="floating-particles"></div>;
};

export default FloatingParticles;